import React from "react";
import Modal from "../../../../elements/Modal";
import ManageUser from "../ManageUser";

const ManageUserModal = ({
  open,
  close = () => {},
  getResponse = () => {},
  data = {},
}) => {
  return (
    <Modal isOpen={open} setIsOpen={close} size="xl2" title={data?._id?"Update User":"Add User"}>
      <ManageUser getResponse={getResponse} close={close} data={data} />
    </Modal>
  );
};

export default ManageUserModal;
